import { api } from '../api';
import type { EntityAttributeLabelRow, EntityAttributeRow } from '@/types/domain';

export const attributesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listAttributeLabels: builder.query<EntityAttributeLabelRow[], number>({
      query: (entityTypeId) => `/entity-types/${entityTypeId}/attribute-labels`,
      providesTags: (_r, _e, entityTypeId) => [
        { type: 'EntityAttributeLabel', id: entityTypeId },
      ],
    }),
    createAttributeLabel: builder.mutation<
      EntityAttributeLabelRow,
      { entityTypeId: number; body: Record<string, unknown> }
    >({
      query: ({ entityTypeId, body }) => ({
        url: `/entity-types/${entityTypeId}/attribute-labels`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_r, _e, { entityTypeId }) => [
        { type: 'EntityAttributeLabel', id: entityTypeId },
      ],
    }),
    updateAttributeLabel: builder.mutation<
      EntityAttributeLabelRow,
      { id: number; entityTypeId: number; body: Record<string, unknown> }
    >({
      query: ({ id, body }) => ({
        url: `/entity-attribute-labels/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (_r, _e, { entityTypeId }) => [
        { type: 'EntityAttributeLabel', id: entityTypeId },
      ],
    }),
    deleteAttributeLabel: builder.mutation<
      EntityAttributeLabelRow,
      { id: number; entityTypeId: number }
    >({
      query: ({ id }) => ({
        url: `/entity-attribute-labels/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_r, _e, { entityTypeId }) => [
        { type: 'EntityAttributeLabel', id: entityTypeId },
      ],
    }),
    listEntityAttributes: builder.query<EntityAttributeRow[], number>({
      query: (entityId) => `/entities/${entityId}/attributes`,
      providesTags: (_r, _e, entityId) => [
        { type: 'EntityAttribute', id: entityId },
      ],
    }),
    createEntityAttribute: builder.mutation<
      EntityAttributeRow,
      { entityId: number; body: Record<string, unknown> }
    >({
      query: ({ entityId, body }) => ({
        url: `/entities/${entityId}/attributes`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_r, _e, { entityId }) => [
        { type: 'EntityAttribute', id: entityId },
      ],
    }),
    updateEntityAttribute: builder.mutation<
      EntityAttributeRow,
      { id: string; entityId: number; body: Record<string, unknown> }
    >({
      query: ({ id, body }) => ({
        url: `/entity-attributes/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (_r, _e, { entityId }) => [
        { type: 'EntityAttribute', id: entityId },
      ],
    }),
    deleteEntityAttribute: builder.mutation<
      EntityAttributeRow,
      { id: string; entityId: number }
    >({
      query: ({ id }) => ({
        url: `/entity-attributes/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_r, _e, { entityId }) => [
        { type: 'EntityAttribute', id: entityId },
      ],
    }),
  }),
});

export const {
  useListAttributeLabelsQuery,
  useCreateAttributeLabelMutation,
  useUpdateAttributeLabelMutation,
  useDeleteAttributeLabelMutation,
  useListEntityAttributesQuery,
  useCreateEntityAttributeMutation,
  useUpdateEntityAttributeMutation,
  useDeleteEntityAttributeMutation,
} = attributesApi;
